import React, { useEffect, useState } from 'react';

import { Col, Row, Spinner } from 'react-bootstrap';
import { FaFilePdf } from 'react-icons/fa';

import { DocumentErrorNotice } from '../../../components';
import useIsMobileScreen from '../../../hooks/useCheckIsMobile';
import { fetchPdfLinkUrl, fetchPdfObjectUrl, isPdfMissing } from '../../../utils/fetchPdfObjectUrl';

const NewDocument = ({ id, dq, loadingAutoselect }) => {
  const isMobile = useIsMobileScreen();
  const [pdfError, setPdfError] = useState(false);
  const [dqPdfDocument, setDqPdfDocument] = useState('');
  const [pdfVersion, setPdfVersion] = useState(0);
  const [pdfLoading, setPdfLoading] = useState(false);

  const getPDF = async (pdf, isCancelled = () => false) => {
    setPdfLoading(true);
    try {
      // Mobile opens the document in its own tab, so give the anchor the presigned URL.
      // Desktop embeds it, which must be a blob so no second S3 request is made.
      const key = `dqf-assembling/${pdf}`;
      const url = isMobile ? await fetchPdfLinkUrl(key) : await fetchPdfObjectUrl(key);
      if (isCancelled()) {
        if (!isMobile) URL.revokeObjectURL(url);
        return;
      }
      setDqPdfDocument(url);
      setPdfError(false);
    } catch (err) {
      if (isCancelled()) return;
      console.log('This is the error', err);
      setPdfError(isPdfMissing(err) ? 'missing' : 'failed');
    } finally {
      if (!isCancelled()) setPdfLoading(false);
    }
  };

  useEffect(() => {
    if (!dq) return undefined;
    let cancelled = false;
    getPDF(`${id}.pdf`, () => cancelled);
    return () => {
      cancelled = true;
    };
  }, [id, dq?.id, pdfVersion, isMobile]);

  // Release the previous blob when it is replaced, and the last one on unmount.
  useEffect(
    () => () => {
      if (dqPdfDocument?.startsWith('blob:')) URL.revokeObjectURL(dqPdfDocument);
    },
    [dqPdfDocument],
  );

  return (
    <>
      <Row className="pt-1 mb-3 mt-3">
        <Col className="font-weight-bold">New Driver Qualification Document</Col>
      </Row>

      {!loadingAutoselect && pdfLoading && <Spinner animation="border" />}
      {!loadingAutoselect && !pdfLoading && pdfError === 'missing' && (
        <DocumentErrorNotice message="No document has been attached to this file." hint={null} />
      )}
      {!loadingAutoselect && !pdfLoading && pdfError === 'failed' && (
        <DocumentErrorNotice onRetry={() => setPdfVersion(version => version + 1)} />
      )}
      {!loadingAutoselect &&
        !pdfLoading &&
        !pdfError &&
        dqPdfDocument &&
        (isMobile ? (
          <>
            <span>
              <a href={dqPdfDocument} data-ajax="false" target="_blank" rel="noreferrer">
                <FaFilePdf size={60} /> View Document
              </a>
            </span>
          </>
        ) : (
          <iframe src={dqPdfDocument} height="600" width="100%" title="dqPdfDcument" />
        ))}

      {loadingAutoselect && <Spinner animation="border" />}
    </>
  );
};

export default NewDocument;
